import { render } from "./ShieldComponent.vue?vue&type=template&id=de58c798&lang=true"
import script from "./ShieldComponent.vue?vue&type=script&lang=js"
export * from "./ShieldComponent.vue?vue&type=script&lang=js"

import "./ShieldComponent.vue?vue&type=style&index=0&id=de58c798&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__